<template>
  <div id="app">
    <Navbar  v-if="this.userLogin" />
    <div class="main">
      <div class="sideBar"  v-if="this.userLogin">
        <Sidebar />
      </div>
      <div class="routePage">
        <router-view />
      </div>
    </div>
    <div class="footer"  v-if="this.userLogin">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Sidebar from "./components/Sidebar.vue";
import Footer from "./components/Footer.vue";
// import Swal from "sweetalert2";
// // import html2pdf from "html2pdf.js";
import moment from 'moment';

export default {
  name: "App",
  components: {
    Navbar,
    Sidebar,
    Footer,
  },
  computed: {
    userLogin() {
      return this.$store.state.isLogin;
    },
  },
  created() { 
    if (localStorage.getItem("access_token")) {
      console.log("ada");
      this.$store.commit("setIsLogin", true);
    } else {
      console.log("tidak ada");
      this.$store.commit("setIsLogin", false);
      this.$router.push("/login");
    }
  },
  methods: {

    cekSotrage() {
      // Swal.fire("Peringatan", "Segera Lengkapi data 2023 Anda", "warning");
      let y = 0
      let thisDate = moment(new Date()).format("YYYY-MM-DD")
      if (!localStorage.getItem("access_token")) y++
      if (localStorage.getItem("date") !== thisDate || !localStorage.getItem("date")) y++
      
      if(y > 0) {
        this.$store.commit("setIsLogin", false);
        localStorage.clear()
        this.$router.push("/login")
      }
    }
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif,;
  /* -webkit-font-smoothing: antialiased; */
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  padding: 0;
}
* {
  font-family: "Segoe UI";
}
.main {
  /* background-color: aqua; */
  width: 100%;
  /* height: 100%; */
  display: flex;
}

.routePage {
  width: 100%;
  display: flex;
  min-height: 85vh;
}

.mainPage {
  min-height: 80vh;
  width: 100%;
  height: 100%;
  padding: 10px 5px 10px 10px;
  background-color: #faf7f7;
}

.sideBar {
  max-width: 280px;
  min-width: 11rem;
  /* background-color: #2c3e50; */
}

.modal p {
  text-align: left;
}

/* in Main Page */
.inRow {
  display: flex;
  flex-direction: row;
  /* width: 100%; */
  justify-content: center;
}
.inCol {
  display: flex;
  flex-direction: column;
}
#headPage {
  text-align: left;
  font-size: 42px;
  font-weight: 500;
  margin: 0;
  color: #BD3B38;
  font-family: Avenir, Helvetica, Arial, sans-serif,;
  /* font-family: 'Mountains of Christmas', serif; */
}
/* memberikan class untuk row */
.inLine {
  display: flex;
}

table td {
  text-align: left;
}

.uang {
  text-align: right;
}

#cardTable {
  font-size: 20px;
  font-weight: 400;
  margin-top: 10px;
}

.tableRow {
  overflow-x: auto;
  overflow-y: auto;
}

#tableData {
  min-width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  margin-top: 10px;
}
#tableData th {
  font-size: 12px;
}
#tableData td {
  font-size: 14px;
  padding: 2px 3px;
  font-weight: 400;
}
#tableData td #action {
  background-color: aquamarine;
}
#tableData button {
  width: 20px;
  height: 20px;
  background-color: transparent;
  border: none;
  padding: 0px;
}
option {
  font-size: 12px;
}
#tableData lord-icon {
  width: 20px;
  height: 20px;
}
#titleRow {
  min-height: 24px;
  text-align: left;
  font-size: 32px;
  margin: 10px 0 0 0;
}
#inputTitle {
  margin: 0;
  /* font-size: 14px; */
  text-align: left;
  font-weight: 500;
}
.filterRow #cardFilter {
  flex: 1;
  margin: 0 10px;
}

.card {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 3px 10px;
  margin: 0px 3px;
  padding: 20px;
}
#titleCard {
  text-align: left;
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}

#amountCard {
  text-align: right;
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;
}

/* Card */
#startBalance {
  background-color: #17a2b8;
}
#inCard {
  background-color: #28a745;
}
#outCard {
  background-color: #e83e8c;
}
#balanceCard {
  background-color: #007bff;
}

.loading {
  min-width: 100%;
}

.spinner-border {
  background-color: #007bff;
  width: 200px;
  height: 200px;
}

#printer {
  background-color: transparent;
  border: none;
  text-align: right;
  max-width: 24px;
}

/* Pagination */
.pagination button {
  background-color: transparent;
  border: none;
}

.pagination p {
  margin: 0;
}

.pagination {
  width: 100%;
  justify-content: center;
}

#addModal {
  background-color: #188f1e;
  border: none;
}
#resetFilter {
  margin-left: 10px;
  background-color: #007bff;
  border: none;
}
/* modal */

.modal .inCol {
  flex: 1;
  margin: 0 2px;
}

.modal p {
  text-align: left;
  margin: 0;
  font-weight: 500;
}

.modal .inRow {
  margin-top: 3px;
}

.custom-select,
.form-control {
  font-size: 11px !important;
  padding: 4px 20px 4px 8px !important;
}
b-input {
  /* padding: 4px 20px; */
  font-size: 40px;
  background-color: #17a2b8;
}

/* option {
  font-size: 11px;
} */


/* Print Area */
#printArea {
  display: none;
  font-size: 12px;
  background-color: #ffffff;
  padding: 50px 24px 12px 24px;
}

.headPrint {
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  font-size: 16px;
  align-items: center;
}
#titlePrint {
  font-size: 16px;
}
#datePrint {
  font-size: 11px;
}

hr {
  margin-top: 0rem;
}

#printTable td {
  font-size: 12px;
  padding: 2px 10px 2px 8px;
}
#printTable #keyTable {
  /* padding-right: 200px !important; */
  /* background-color: #007BFF; */
  width: 150px;
}
#printTable #titikDua {
  /* background-color: #17A2B8; */
  width: 15px;
}
.signArea .inRow {
  justify-content: space-around;
}
.signArea #name {
  text-align: center;
  margin-bottom: 60px;
}


img#status{
    min-width: 28px;
    max-width: 40px;
}
#edited {
  min-width: 28px;
    max-width: 40px;
}


td img {
  max-width: 18px;
}

#deleteButton {
  background-color: transparent;
  border: none;
}
.modal {
  padding: 20px !important;
}
.modal button img {
  max-width: 24px;
}

.modal-content {
  margin-top: 4rem;
  padding: 20px;
}
</style>
